import React from 'react';
import {OutlineFilter} from '@pixi/filter-outline';

export type CheatsButtonButtonProps = {
    onClick?: () => void;
    position?: any;
    x?: number;
    y?: number;
    height: number | 'auto';
    width: number | 'auto';
    disabled?: boolean;
};

export class CheatsButton<P extends CheatsButtonButtonProps> extends React.Component<P, any> {
    protected static STATE = {
        NORMAL: {
            filters: [new OutlineFilter(2, 0x000000)],
            background: 0x808898
        },
        OVER: {
            filters: [new OutlineFilter(2, 0xFF0000)],
            background: 0x697281
        },
        DOWN: {
            filters: [new OutlineFilter(1, 0x000000)],
            background: 0xA7B2C7
        }
    };

    constructor(props: P) {
        super(props);

        this.state = {
            currentState: CheatsButton.STATE.NORMAL
        };
    }

    protected onPointerTap(): void {

    }

    protected onPointerUp(): void {
        this.setState({currentState: CheatsButton.STATE.OVER});
    }

    protected onPointerUpOutside(): void {
        this.setState({currentState: CheatsButton.STATE.NORMAL});
    }

    protected onPointerDown(): void {
        this.setState({currentState: CheatsButton.STATE.DOWN});
    }

    protected onPointerOver(): void {
        this.setState({currentState: CheatsButton.STATE.OVER});
    }

    protected onPointerOut(): void {
        this.setState({currentState: CheatsButton.STATE.NORMAL});
    }

    protected getContainerProps(): any {
        const containerProps: any = {
            interactive: !this.props.disabled,
            buttonMode: !this.props.disabled,
            pointertap: this.onPointerTap.bind(this),
            pointerdown: this.onPointerDown.bind(this),
            pointerup: this.onPointerUp.bind(this),
            pointerupoutside: this.onPointerUpOutside.bind(this),
            pointerover: this.onPointerOver.bind(this),
            pointerout: this.onPointerOut.bind(this),
            filters: this.state.currentState.filters
        };

        if (this.props.position) {
            containerProps.position = this.props.position;
        }

        if (this.props.x !== undefined) {
            containerProps.x = this.props.x;
        }

        if (this.props.y !== undefined) {
            containerProps.y = this.props.y;
        }

        return containerProps;
    }
}
